<div class="row">
  <div class="col-md-12">
    <div class="card">

      <div class="card-header card-header-icon card-header-rose">
        <div class="card-icon">
          <i class="material-icons"></i>
        </div>
        <h3 class="card-title" style="    font-weight: 500;"><span class="material-icons">
local_shipping
</span> Add order items to this package</h3>

      </div>
      <div class="card-body">
        <div mat-dialog-content>


<div *ngIf="errors" class="row">
  <div *ngFor="let error of errors" class="col-md-12 alert alert-danger">
    {{error.message}}
  </div>
</div>
<div class="row">

  <div id="waitloadOrderItems" style="display: none" class="col-md-12 alert alert-warning">
    <i class="fa fa-circle-o-notch fa-spin fa-fw text-white"></i> Please wait while we retrive the order's items from the server
  </div>

  <div id="successdiv" style="display: none; position: relative;" class="col-md-12 alert alert-success">
    <span style="    margin-right: 10px; position: absolute;left: 2px" class="material-icons text-white">
done
</span> The items selected have been added successfully!
  </div>
  
</div>
        
           
<div class="form-group">
                <label class="bmd-label-floating">Select a Package which you want to add Items</label>
                <select name="box_id" [(ngModel)]="boxId" #rep_id="ngModel" placeholder="Client Name" class="form-control" required>
                    <option value=null disabled>please select an option</option>
                    <option *ngFor="let box of boxesInfo" [value]="box.id">  {{ box.packageCode }} - Weight: {{box.weightValue}} {{box.weightUnit}} Dimensions: {{box.dimensionsHeight}}/{{box.dimensionsWidth}}/{{box.dimensionsLength}} {{box.dimensionsUnit}}</option>
                </select>
            </div>

<div class="form-group">
            <label for="options">Items :</label>
            <div *ngFor="let option of ordersNotShipped">
                <label>
                    <input type="checkbox"
                           name="options.item"
                           value="{{option.id}}"
                           [(ngModel)]="option.checked"
                          />
                    {{option.item}} - {{option.serialnumber}}
                </label>
            </div>
        </div>
        
         
    <button class="btn btn-success" (click)="onSubmit()">Add Items to this Package</button>    

    
        </div>
      </div>
    </div>
  </div>



</div>
 <div mat-dialog-actions>
  <button mat-button [mat-dialog-close]="data" class="btn btn-danger" cdkFocusInitial>Close</button>
</div>